import * as React from "react";

import { App } from "../../components/App";

export const RoleDescriptionViewerApp = () => {
  const reactComponent = <App />;
  return reactComponent;
};
